/**
 * Inline lock-icon SVGs.
 *
 * Two variants: `closed` for the masked state, `open` for the revealed
 * state. Combined with the soft-amber background, the open/closed icon
 * gives a colour-blind-safe second signal that the field is no longer
 * masked (per WCAG 2.2 AA: do not use colour as the only signal).
 *
 * Stroke-only, `currentColor`, so the parent's text colour drives both.
 * No external icon dependency.
 */

import type { SVGProps } from 'react'

export function LockClosedIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <rect x="4" y="11" width="16" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  )
}

export function LockOpenIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <rect x="4" y="11" width="16" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 7.5-2" />
    </svg>
  )
}
